import { render } from "./pet-form.vue?vue&type=template&id=2c1516d5&scoped=true"
import script from "./pet-form.vue?vue&type=script&lang=js"
export * from "./pet-form.vue?vue&type=script&lang=js"

import "./pet-form.vue?vue&type=style&index=0&id=2c1516d5&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Codes/d86e-client-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1516d5"]])

export default __exports__